import { apiCall } from './gqlClient';

const GETWORKOUTS_QUERY = `
  query getWorkouts {
    getWorkouts
    {
      id
			providerId
			title
			description
			level
			dateCreated
			imageId
			thumbnailUrl
			price
			active
      ...fragments
    }
  }`;

export const getWorkoutsApiCall = async (fragments = null) => apiCall({ query: GETWORKOUTS_QUERY, variables: {}, fragments });

const GETWORKOUTDETAILS_QUERY = `
  query getWorkoutDetails($id: String!, $userId: Int, $groupId: Int) {
    getWorkoutDetails(id: $id, userId: $userId, groupId: $groupId)
    {
      id
			providerId
			title
			description
			level
			dateCreated
			imageId
			thumbnailUrl
			price
			active
      ...fragments
    }
  }`;

export const getWorkoutDetailsApiCall = async ({id, userId, groupId}, fragments = null) => apiCall({ query: GETWORKOUTDETAILS_QUERY, variables: {id, userId, groupId}, fragments });

const CREATEWORKOUT_QUERY = `
  mutation createWorkout($request: WorkoutInput!) {
    createWorkout(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const createWorkoutApiCall = async ({request}, fragments = null) => apiCall({ query: CREATEWORKOUT_QUERY, variables: {request}, fragments });

const UPDATEWORKOUT_QUERY = `
  mutation updateWorkout($request: WorkoutUpdateInput!) {
    updateWorkout(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const updateWorkoutApiCall = async ({request}, fragments = null) => apiCall({ query: UPDATEWORKOUT_QUERY, variables: {request}, fragments });

const CREATECIRCUIT_QUERY = `
  mutation createCircuit($workoutId: String!, $title: String!) {
    createCircuit(workoutId: $workoutId, title: $title)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const createCircuitApiCall = async ({workoutId, title}, fragments = null) => apiCall({ query: CREATECIRCUIT_QUERY, variables: {workoutId, title}, fragments });

const UPDATECIRCUIT_QUERY = `
  mutation updateCircuit($request: CircuitInput!) {
    updateCircuit(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const updateCircuitApiCall = async ({request}, fragments = null) => apiCall({ query: UPDATECIRCUIT_QUERY, variables: {request}, fragments });

const CREATECIRCUITEXERCISE_QUERY = `
  mutation createCircuitExercise($circuitId: String!) {
    createCircuitExercise(circuitId: $circuitId)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const createCircuitExerciseApiCall = async ({circuitId}, fragments = null) => apiCall({ query: CREATECIRCUITEXERCISE_QUERY, variables: {circuitId}, fragments });

const UPDATECIRCUITEXERCISE_QUERY = `
  mutation updateCircuitExercise($request: CircuitItemInput!) {
    updateCircuitExercise(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const updateCircuitExerciseApiCall = async ({request}, fragments = null) => apiCall({ query: UPDATECIRCUITEXERCISE_QUERY, variables: {request}, fragments });

const CREATECIRCUITEXERCISEEQUIPMENT_QUERY = `
  mutation createCircuitExerciseEquipment($request: CircuitExerciseEquipmentInput!) {
    createCircuitExerciseEquipment(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const createCircuitExerciseEquipmentApiCall = async ({request}, fragments = null) => apiCall({ query: CREATECIRCUITEXERCISEEQUIPMENT_QUERY, variables: {request}, fragments });

const UPDATECIRCUITEXERCISEEQUIPMENT_QUERY = `
  mutation updateCircuitExerciseEquipment($request: CircuitExerciseEquipmentInput!) {
    updateCircuitExerciseEquipment(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const updateCircuitExerciseEquipmentApiCall = async ({request}, fragments = null) => apiCall({ query: UPDATECIRCUITEXERCISEEQUIPMENT_QUERY, variables: {request}, fragments });

const DELETEWORKOUT_QUERY = `
  mutation deleteWorkout($id: String!) {
    deleteWorkout(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const deleteWorkoutApiCall = async ({id}, fragments = null) => apiCall({ query: DELETEWORKOUT_QUERY, variables: {id}, fragments });

const DUPLICATEWORKOUT_QUERY = `
  mutation duplicateWorkout($id: String!) {
    duplicateWorkout(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const duplicateWorkoutApiCall = async ({id}, fragments = null) => apiCall({ query: DUPLICATEWORKOUT_QUERY, variables: {id}, fragments });

const TOGGLEWORKOUTSTATUS_QUERY = `
  mutation toggleWorkoutStatus($id: String!, $active: Boolean!) {
    toggleWorkoutStatus(id: $id, active: $active)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const toggleWorkoutStatusApiCall = async ({id, active}, fragments = null) => apiCall({ query: TOGGLEWORKOUTSTATUS_QUERY, variables: {id, active}, fragments });

const DELETEWORKOUTITEM_QUERY = `
  mutation deleteWorkoutItem($id: String!) {
    deleteWorkoutItem(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const deleteWorkoutItemApiCall = async ({id}, fragments = null) => apiCall({ query: DELETEWORKOUTITEM_QUERY, variables: {id}, fragments });

const DELETEWORKOUTEQUIPMENTOVERRIDEITEM_QUERY = `
  mutation deleteWorkoutEquipmentOverrideItem($id: String!) {
    deleteWorkoutEquipmentOverrideItem(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const deleteWorkoutEquipmentOverrideItemApiCall = async ({id}, fragments = null) => apiCall({ query: DELETEWORKOUTEQUIPMENTOVERRIDEITEM_QUERY, variables: {id}, fragments });

const REORDERCIRCUITITEMS_QUERY = `
  mutation reorderCircuitItems($firstId: String!, $secondId: String!) {
    reorderCircuitItems(firstId: $firstId, secondId: $secondId)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const reorderCircuitItemsApiCall = async ({firstId, secondId}, fragments = null) => apiCall({ query: REORDERCIRCUITITEMS_QUERY, variables: {firstId, secondId}, fragments });
